import { __ } from "src/libs/utilities"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import __composition from "../../assets/img/layout.svg" 
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { Icon, Position, Tooltip } from "@blueprintjs/core"

/* Protopia Ecosystem component */
export interface ICompositionScalarProps extends ICompositeWidgetProps {
   
}
const CompositionScalar = (props: ICompositionScalarProps): JSX.Element => {
    
    console.log( props )
    const container = props.value.container || DIALOG_SIZE.LARGE
    return <div className="card  my-3 mr-3">
        <div className="lead letter-spacing-2 uppercase py-2 px-3 ">
            <div className="d-flex align-items-center">
                <img src={ __composition } alt="" height={22} />
                <div className="d-flex small ml-2">
                    { __( "Composition")  }
                </div> 
            </div>
        </div>
        <div className='landing-composition-scalar '>
            <div className="section-contour">
                <div className="h-center"/>
                <div className="v-center"/>
                <div className="v-conntainer-rules v-micro"/>
                <div className="v-conntainer-rules v-minimal"/>
                <div className="v-conntainer-rules v-little"/>
                <div className="v-conntainer-rules v-normal"/>
                <div className="v-conntainer-rules v-large"/>
                <div className={`v-container-handler v-${ container }`}>
                    <div className="handle-start" />
                    <div className="handle-finish" />
                    <div className={`v-label`}>
                        <Tooltip
                            interactionKind="hover"
                            position={Position.TOP_LEFT}

                            portalClassName="z-index-120"
                            content={ <div className="small">{__("Container width")}</div>}
                        >
                            <span className="pointer">{ container }</span>
                        </Tooltip> 
                    </div>
                </div>
                <div className={`section-data-cont v-${ container }`}>
                    <div className="text-before">
                        <Icon icon="plus" size={10} />
                        {__("Text before")}
                    </div>
                    <div className="text-after">
                        <Icon icon="plus" size={10} />
                        {__("Text after")}
                    </div>
                    <div className="v-height">
                        <div className="up-btn"></div>
                        <div className="down-btn"></div>
                        <div>
                            
                        </div>
                    </div>
                </div>
                <div className="h-section-hendler">
                    <div className="handle-start" />
                    <div className="handle-finish" />
                    <div className={`h-label`}>
                        <Tooltip
                            interactionKind="hover"
                            position={Position.BOTTOM_RIGHT}

                            portalClassName="z-index-120"
                            content={ <div className="small">{__("Section height")}</div>}
                        >
                            <span className="pointer">{ 
                                props.origin?.height
                            }</span>
                        </Tooltip> 
                    </div>
                </div>
            </div>
        </div>
    </div>
}
export default CompositionScalar